/**
 * Value mapping for a Switch with `fieldProps.inverted`: the form keeps the
 * stored boolean (e.g. `is_nullable`), the toggle shows its negation (e.g.
 * "Required"). A missing value (undefined/null) maps to "off" in both
 * directions, matching a plain Switch.
 */
export const toDisplayedSwitchValue = (stored: unknown, inverted?: boolean): boolean => {
    if (stored === undefined || stored === null) {
        return false;
    }
    return inverted ? stored !== true : stored === true;
};

export const toStoredSwitchValue = (checked: boolean, inverted?: boolean): boolean =>
    inverted ? !checked : checked;
